import { render, staticRenderFns } from "./FPX.vue?vue&type=template&id=1211304d&scoped=true&"
import script from "./FPX.vue?vue&type=script&lang=js&"
export * from "./FPX.vue?vue&type=script&lang=js&"
import style0 from "./FPX.vue?vue&type=style&index=0&id=1211304d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1211304d",
  null
  
)

export default component.exports